const black = "#000000";
const darkgrey = "#333333";
const green = "#009933";
const grey = "#999999";
const lightgrey = "#eeeeee";
const red = "#ff4433";
const white = "#ffffff";

export { black, darkgrey, green, grey, lightgrey, red, white };
